<script>
import { mapState, mapActions } from 'vuex';
// import CustomComponent from '@/components/CustomComponent';
/* import { getAsset } from '@/scripts/utils'; */

export default {
  name: 'DashboardTabs',
  components: {},
  props: {
    gameSetup: {
      type: Object,
      required: true,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      indexSlide: 0,
    };
  },
  computed: {
    ...mapState(['games']),
  },
  mounted() {},
  created() {},
  methods: {
    ...mapActions({}),
    getBackgroundImage(game) {
      const { gameSetup } = this;
      const { images } = game;
      const { menu_icon_active: active, menu_icon_inactive: inactive } = images;
      const isActive = gameSetup.id === game.id;
      const imageSetup = isActive ? active : inactive;
      const result = imageSetup.url;

      return result;
    },
  },
};
</script>

<template>
  <div class="list-tabs">
    <div
      class="slide list-tabs__item"
      v-for="({ id, title }, index) in games"
      :key="id + 1"
    >
      <button
        :class="{
          [id]: true,
          'btn-games': true,
          'is-active': id === gameSetup.id,
        }"
        :disabled="disabled || id === gameSetup.id"
        @click="$emit('change', id)"
      >
        <div class="btn-games__bg">
          <img :src="getBackgroundImage(games[index])" />
        </div>

        <div class="btn-games__content"></div>
      </button>
    </div>
  </div>
</template>

<style scoped lang="scss">
@import '@/styles/variables.scss';
.btn-games {
  height: 60px;
  width: 130px;
  border-radius: 12px;
  overflow: hidden;
  position: relative;
  background: transparent;
  padding: 0;
  outline: none;
  margin: 0;
  border: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: Poppins-Medium;
  font-size: 14px;
  line-height: 20px;
  color: rgba(255, 255, 255, 0.8);
  text-align: center;
  user-select: none;

  &.is-active::before {
    opacity: 0;
  }

  &:not(.is-active) {
    cursor: pointer;
  }

  &:before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: #191634;
    opacity: 0.7;
    border-radius: 12px;
    transition: all 0.2s;
  }

  &:hover:before {
    opacity: 0;
  }

  &__bg {
    width: 100%;
    height: 100%;
    display: flex;

    img {
      display: flex;
      width: 100%;
      height: 100%;
    }
  }

  &__content {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;

    img {
      display: flex;
    }
  }

  &.fortnite,
  &.warzone {
    .btn-games__content {
      img {
        max-height: 20px;
      }
    }
  }

  &.dota-2 {
    .btn-games__content {
      img {
        max-height: 40px;
      }
    }
  }
  &.cs-go,
  &.pubg {
    .btn-games__content {
      img {
        max-height: 30px;
      }
    }
  }
}

.list-tabs {
  width: 100%;
  display: flex;
  align-items: center;

  &__item {
    margin: 0 10px;
    display: flex;
  }
}
</style>
